import React, { useEffect, useState as useStateClient } from 'react';
import moment from 'moment-timezone';
import loadable from '@loadable/component';
import { SIGN_UP_SRC } from '../../consts/profile.const';
import { IMG_RESIZES } from '../../consts/resizer.consts';
import { ImageHelper } from '../../classes/image-helper.class';
import useMobileScreen from '../../services/hooks/useMobileScreen';
import { RouteFormatter } from '../../routes';
import DesktopPhotoGallery from './desktop-photo-gallery';
import { COOKIE_PARAM_NAME } from '../../consts/cookies.consts';
import defaultUserLogo from 'src/assets/svg/SvgProfile.svg?url';
import { AUTH_TESTS } from '../../pages/spot-view-page/auth-test.const';
import MobileSubPage from '../mobile-sub-page';
import ModalMobile from '../modal-mobile';
import SniffButton from '../sniff-button';
import PictureSet from '../picture-set';
import SeoReview from '../seo-review';
import Rating from '../rating';
import SvgMessageBubble from 'src/assets/svg/SvgMessageBubble.svg';
import SvgChatTriangle from 'src/assets/svg/SvgChatTriangle.svg';
import SvgSubscription from 'src/assets/svg/SvgSubscription.svg';
import SvgCalendar from 'src/assets/svg/SvgCalendar.svg';
import SvgBin from 'src/assets/svg/SvgBin.svg';
import './index.scss';

const useHistory = require('../../services/hooks/useHistory');
const CookieService = require('../../services/cookie.service');
const useAddReply = require('../../services/hooks/useAddReply');
const useDeleteReply = require('../../services/hooks/useDeleteReply');

const SimpleSniffTextarea = loadable(() => import('../sniff-textarea'));

const RenderSniffpassBadge = ({ handleClick }) => (
    <div className="spot-badge-offer-membership" onClick={handleClick}>
        <SvgSubscription />
        <span>Sniffpass</span>
    </div>
);

const RenderReviewPhotos = ({
    isInitOpen,
    isMobile,
    photos = [],
    reviewId,
    stars,
    spotId,
    user,
    userDetails,
    useState,
    setIsBlurTest = () => {},
    isBlurTest,
}) => {
    const [openReviewPhotos, setOpenReviewPhotos] = useState(false);
    const [desktopPhotoCount, setDesktopPhotoCount] = useState(0);
    const [desktopPhotoGallery, setDesktopPhotoGallery] = useState(false);
    const length = Math.min(photos.length, 4);
    const excess = 4 || photos.length - length;
    const imgSrc = photos.map((v) => ImageHelper.getUrlFromOptions(v.imageAws, `full-fit-in/${IMG_RESIZES.x450}`));
    const firstName = user.nameAndInitial.split(' ');
    const alt = `${firstName ? firstName[0] : user.nameAndInitial}'s review photo`;
    const title = `Pictures by ${user.nameAndInitial}`;
    const userIMG = user.avatarAws ? ImageHelper.getUrlFromOptions(user.avatarAws, `fit-in/${IMG_RESIZES.x0128}`) : defaultUserLogo;
    const guestJoinedAt = moment(user.createdAt).format('D MMMM YYYY');

    const handleBackDesktopGallery = () => setDesktopPhotoCount((c) => (c - 1 < 0 ? photos.length : c - 1));
    const handleNextDesktopGallery = () => setDesktopPhotoCount((c) => (c + 1 == photos.length ? 0 : c + 1));

    const toggleOpenReviewPhotos = async (idx) => {
        // guest auth test
        if (!userDetails?.id) {
            const re = `${window.location.pathname}#${AUTH_TESTS.GUEST_REVIEW_PHOTO}-${reviewId}`;

            CookieService.default.set(COOKIE_PARAM_NAME.SIGN_UP_FROM, SIGN_UP_SRC.SPOT_DETAILS_WEB, { expires: 1 });
            CookieService.default.set(COOKIE_PARAM_NAME.REDIRECT, re);
            setIsBlurTest(true);
            isMobile ? setOpenReviewPhotos((o) => !o) : toggleDesktopPhotoGallery(idx);
            return;
        }

        isMobile ? setOpenReviewPhotos((o) => !o) : toggleDesktopPhotoGallery(idx);
    };

    const toggleDesktopPhotoGallery = (idx = 0) => {
        setDesktopPhotoGallery((o) => !o);
        setDesktopPhotoCount(idx);
    };

    useEffect(() => {
        if (!isBlurTest) {
            if (isMobile) {
                setOpenReviewPhotos(false);
            } else {
                setDesktopPhotoGallery(false);
                setDesktopPhotoCount(0);
            }
        }
    }, [isBlurTest]);

    useEffect(() => {
        setOpenReviewPhotos(false);
        setDesktopPhotoGallery(false);
        setDesktopPhotoCount(0);
    }, [spotId]);

    useEffect(() => {
        if (!isInitOpen) {
            return;
        }

        toggleOpenReviewPhotos(0);
    }, []);

    return (
        <>
            <div className={`spot-review-guest-photos photos-${length}`}>
                {length == 1 ? (
                    <PictureSet imgs={imgSrc[0]} width={424} height={198} alt={alt} onClick={() => toggleOpenReviewPhotos(0)} />
                ) : length == 2 ? (
                    <>
                        <PictureSet imgs={imgSrc[0]} width={210} height={198} alt={alt} onClick={() => toggleOpenReviewPhotos(0)} />
                        <PictureSet imgs={imgSrc[1]} width={210} height={198} alt={alt} onClick={() => toggleOpenReviewPhotos(1)} />
                    </>
                ) : length == 3 ? (
                    <>
                        <PictureSet imgs={imgSrc[0]} width={210} height={198} alt={alt} onClick={() => toggleOpenReviewPhotos(0)} />
                        <PictureSet imgs={imgSrc[1]} width={210} height={97} alt={alt} onClick={() => toggleOpenReviewPhotos(1)} />
                        <PictureSet imgs={imgSrc[2]} width={210} height={97} alt={alt} onClick={() => toggleOpenReviewPhotos(2)} />
                    </>
                ) : (
                    <>
                        <PictureSet imgs={imgSrc[0]} width={210} height={97} alt={alt} onClick={() => toggleOpenReviewPhotos(0)} />
                        <PictureSet imgs={imgSrc[1]} width={210} height={97} alt={alt} onClick={() => toggleOpenReviewPhotos(1)} />
                        <PictureSet imgs={imgSrc[2]} width={210} height={97} alt={alt} onClick={() => toggleOpenReviewPhotos(2)} />
                        {excess > 0 ? (
                            <div className="photos-4__excess">
                                <PictureSet imgs={imgSrc[3]} width={210} height={97} alt={alt} />
                                <div onClick={() => toggleOpenReviewPhotos(3)}>+{excess}</div>
                            </div>
                        ) : (
                            <PictureSet imgs={imgSrc[3]} width={210} height={97} alt={alt} onClick={() => toggleOpenReviewPhotos(3)} />
                        )}
                    </>
                )}
            </div>
            {isMobile ? (
                <MobileSubPage title={title} show={openReviewPhotos} onBack={toggleOpenReviewPhotos}>
                    <>
                        <div className="spot-review-guest-photos__header">
                            <div className="spot-review-guest-photos__header_user">
                                <PictureSet imgs={userIMG} width={48} height={48} alt="Guest avatar" />
                                <div>
                                    <div className="snif-p snif-semibold mb-05">{user.nameAndInitial}</div>
                                    <div className="snif-s2">{guestJoinedAt}</div>
                                </div>
                            </div>
                            <Rating className="rating-comment mt-2" value={stars} showNmb={false} />
                        </div>
                        {photos.map((p) => (
                            <PictureSet
                                key={p.id || p.imageAws}
                                imgs={ImageHelper.getUrlFromOptions(p.imageAws, `fit-in/${IMG_RESIZES.x0450}`)}
                                className="spot-review-guest-photos__mdl-item"
                                width={500}
                                height={400}
                                alt={alt}
                            />
                        ))}
                        <div style={{ height: '82px' }} />
                    </>
                </MobileSubPage>
            ) : (
                <DesktopPhotoGallery
                    photos={photos}
                    currentPhoto={desktopPhotoCount}
                    isOpen={desktopPhotoGallery}
                    toggle={toggleDesktopPhotoGallery}
                    user={user}
                    spotId={spotId}
                    handleNext={handleNextDesktopGallery}
                    handleBack={handleBackDesktopGallery}
                    userName={title}
                    userIMG={userIMG}
                />
            )}
        </>
    );
};

const Review = ({
    id,
    comment,
    submittedAt,
    stars,
    spotId,
    reply,
    host,
    profile,
    providedBy,
    userDetails,
    handleSniffpassReviewBadge,
    sniffpassed,
    isSpotDetail,
    isHostReview,
    useStateSSR,
    getUpdatedReviews,
    isMobile: isMobileSSR,
    changeSort,
    sortBy,
    photos,
    spot,
    noRichText,
    serverSSR,
    guestRevPhotoOpen,
    isBlurTest,
    setIsBlurTest = () => {},
    hasHighlightedContent = false,
}) => {
    const history = useStateSSR ? null : useHistory.default();
    const useState = useStateSSR || useStateClient;
    const isMobile = useStateSSR ? isMobileSSR : useMobileScreen();
    const [myReply, setMyReply] = useState(reply);
    const { addReply } = serverSSR ? {} : useAddReply.default();
    const { deleteReply } = serverSSR ? {} : useDeleteReply.default();

    const user = providedBy || {};
    const avatarUrl = user.avatarAws ? ImageHelper.getUrlFromOptions(user.avatarAws, `fit-in/${IMG_RESIZES.x0256}`) : defaultUserLogo;
    const hostAvatarUrl = host?.avatarAws ? ImageHelper.getUrlFromOptions(host?.avatarAws, `fit-in/${IMG_RESIZES.x0256}`) : defaultUserLogo;
    const [modalShow, setModalShow] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [replyText, setReplyText] = useState('');
    const isHost = userDetails?.id == host?.id;

    const isInitOpen = guestRevPhotoOpen == id;

    const today = moment().format('YYYY');
    const reviewDate = moment(submittedAt, 'YYYYMMDD');
    let dateText = reviewDate.get('years') === today ? reviewDate.format('MMM D') : reviewDate.format('MMM D, YYYY');

    if (isHostReview) {
        dateText = reviewDate.format('D MMMM YYYY');
    }

    const handlePostReply = async () => {
        const trimmedText = replyText.trim();

        if (!trimmedText) {
            return;
        }

        const res = await addReply({ variables: { reviewId: id, text: trimmedText } });
        res.data?.createReply && setMyReply(res.data.createReply);
        setModalShow(!modalShow);
        setReplyText('');
        isHostReview && getUpdatedReviews();
        useStateSSR && changeSort(sortBy, true);
    };

    const handleDeleteReply = () => {
        deleteReply({ variables: { id: reply?.id } });
        setDeleteModal(!deleteModal);
        setMyReply(null);
        isHostReview && getUpdatedReviews();
        useStateSSR && changeSort(sortBy, true);
    };

    const handleGoToProfile = () => {
        if (useStateSSR) {
            window.location = RouteFormatter.profile({ id: user.id });
            return;
        }
        history.push(RouteFormatter.profile({ id: user.id }));
    };

    return (
        <React.Fragment>
            {!noRichText && stars > 0 && <SeoReview {...{ comment, spot, stars, user, submittedAt }} />}
            <div className="row">
                <div className="col-md-12">
                    <div className="review-user-info media" onClick={handleGoToProfile}>
                        <PictureSet
                            className="align-self-start rounded-circle user-avatar"
                            imgs={avatarUrl}
                            alt="Guest avatar"
                            SSR={useStateSSR}
                            useState={useStateSSR}
                        />
                        <div className="media-body">
                            <h5 className="user-name snif-p">{user.nameAndInitial}</h5>
                            <div className="comment-date snif-s2">
                                {!isHostReview && <SvgCalendar />}
                                <span className="comment-date__date-text">{dateText}</span>
                                {isSpotDetail && !isHostReview && sniffpassed && (
                                    <>
                                        <span className="comment-date__dot" />
                                        <RenderSniffpassBadge handleClick={handleSniffpassReviewBadge} />
                                    </>
                                )}
                            </div>
                        </div>
                        <Rating className="rating-comment mt-2" value={stars} showNmb={false} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 comment-content">
                    {hasHighlightedContent ? (
                        <p className="snif-p mt-1" dangerouslySetInnerHTML={{ __html: comment }} />
                    ) : (
                        <p className="snif-p mt-1">{comment}</p>
                    )}
                    {isSpotDetail && photos?.length > 0 && (
                        <RenderReviewPhotos
                            {...{
                                isMobile,
                                isInitOpen,
                                photos,
                                serverSSR,
                                spotId,
                                stars,
                                user,
                                userDetails,
                                useState,
                                reviewId: id,
                                isBlurTest,
                                setIsBlurTest,
                            }}
                        />
                    )}
                    {(isHost || myReply?.createdAt) && (
                        <div className="comment-action">
                            {myReply && (
                                <div className="host-replied">
                                    <div className="reply-title">
                                        <div className="user-avatar-sm">
                                            <PictureSet
                                                className="align-self-start rounded-circle"
                                                imgs={hostAvatarUrl}
                                                alt="Host avatar"
                                                SSR={useStateSSR}
                                                useState={useStateSSR}
                                            />
                                            <SvgChatTriangle />
                                        </div>
                                        <p className="snif-s2 snif-s1-pc snif-semibold mb-0">{isHost ? 'You' : 'Host'} replied</p>
                                    </div>
                                </div>
                            )}
                            {!profile && !myReply && isHost && (
                                <>
                                    <p className={`reply-button snif-s1 mb-0 ${modalShow ? 'active' : ''}`} onClick={() => setModalShow(!modalShow)}>
                                        <SvgMessageBubble className="me-1" />
                                        Reply
                                    </p>
                                    {isMobile && (
                                        <ModalMobile
                                            isOpen={modalShow}
                                            toggle={() => setModalShow(!modalShow)}
                                            title="Leave a reply"
                                            className="modal-mobile-reply"
                                        >
                                            <div className="reply-title">
                                                <PictureSet
                                                    className="align-self-start rounded-circle user-avatar-sm"
                                                    imgs={avatarUrl}
                                                    alt="Guest avatar"
                                                    SSR={useStateSSR}
                                                    useState={useStateSSR}
                                                />
                                                <p className="snif-p snif-semibold">{user.nameAndInitial}</p>
                                            </div>
                                            <p className="snif-p mt-1 mb-2">{comment}</p>
                                            <p className="snif-p mt-1 mb-0">Your public reply:</p>
                                            <SimpleSniffTextarea
                                                className="reply-input"
                                                value={replyText}
                                                onChange={(e) => setReplyText(e.target.value)}
                                            />
                                            <p className="text-end mt-2 mb-0">
                                                <SniffButton size="lg" disabled={!replyText} onClick={handlePostReply}>
                                                    Post reply
                                                </SniffButton>
                                            </p>
                                        </ModalMobile>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                    {/* SHOW ONLY IN DESKTOP WHEN HOST OPEN REPLY BOX */}
                    {!myReply && isHost && !isMobile && modalShow && (
                        <div className="host-reply-box">
                            <p className="snif-p mb-1">Your public reply:</p>
                            <SimpleSniffTextarea className="reply-input" value={replyText} onChange={(e) => setReplyText(e.target.value)} />
                            <p className="text-end mt-2 mb-0">
                                <SniffButton size="lg" color="secondary" className="me-2" onClick={() => setModalShow(!modalShow)}>
                                    Cancel
                                </SniffButton>
                                <SniffButton size="lg" disabled={!replyText} onClick={handlePostReply}>
                                    Post reply
                                </SniffButton>
                            </p>
                        </div>
                    )}
                    {myReply?.createdAt && (
                        <>
                            <div className="reply-box">
                                <p className="snif-s1">{myReply?.text}</p>
                                <p className="snif-s2 mb-0 reply-date">
                                    {moment(myReply?.submittedAt || myReply?.createdAt, 'YYYYMMDD').format('D MMMM YYYY')}
                                </p>
                                {!profile && isHost && (
                                    <p className="text-end mb-0">
                                        <SvgBin className="delete-reply" onClick={() => setDeleteModal(!deleteModal)} />
                                    </p>
                                )}
                            </div>
                            <ModalMobile isOpen={deleteModal} toggle={() => setDeleteModal(!deleteModal)} title="Delete your reply">
                                <p className="snif-p mb-2">Are you sure you want to delete this reply?</p>
                                <p className="text-end mb-0">
                                    <SniffButton color="secondary" onClick={handleDeleteReply}>
                                        Delete reply
                                    </SniffButton>
                                </p>
                            </ModalMobile>
                        </>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default Review;
